module.exports = __webpack_public_path__ + "assets/img/factura_ampliado.jpg";